
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select Devices to add to the Bulk Order:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredDevices.length" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>Model & Info</th>
            <th *ngIf="!catalogPricingEnabled">Available Quantity</th>
            <th *ngIf="catalogPricingEnabled">DART Quantity</th>
            <th>Quantity to Order</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let device of displayedDevices; let idx = index;">
            <td><span class="badge badge-secondary mr-2" *ngIf="device.quicksilver">QS</span><b *ngIf="device.type === &quot;accessory&quot;">[Accessory]</b> {{ device.productDescription }} <b>({{ device.productNumber }})</b><br>Device Key: {{ device.deviceKey }}
            </td>
            <td *ngIf="!catalogPricingEnabled">{{ device.maxQuantity > 0 ? device.maxQuantity : 0 }}</td>
            <td *ngIf="catalogPricingEnabled">{{ device.dartQuantity }}</td>
            <td>
              <input class="form-control" type="number" name="device-quantity-number-{{ device.id }}" min="0" max="{{ device.maxQuantity }}" [(ngModel)]="device.quantity" [disabled]="disableAll || device.disabled" (change)="updateQuantity(device)" [ngClass]="{'is-invalid': device.isInvalid}">
            </td>
          </tr>
          <tr *ngIf="displayedDevices.length === 0">
            <td [attr.colspan]="4">
              <p class="text-center empty-table-message">There are no Devices to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>